module.exports = {"id":"191104","name":"Juan Mercier","rating":"73","photo":"./data/images/photos/1/191104.png","club":{"name":"San Lorenzo","logo":"./data/images/clubs/SanLorenzo.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanMercier0.json
// module id = 2220
// module chunks = 0